import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './config/api'; // sets axios.defaults.baseURL before any request
import App from './App';
import { ShieldThemeProvider } from './theme/ThemeContext';
import ThemeSwitcher from './components/ThemeSwitcher';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ShieldThemeProvider>
      {/* App contains BrowserRouter, AuthProvider and all routes */}
      <App />
      {/* Floating palette button — rendered outside App so it stays on
          every page including public routes (landing, login, signup) */}
      <ThemeSwitcher />
    </ShieldThemeProvider>
  </React.StrictMode>
);
